import QuestionPage from '../../templates/question';
import Checkbox from '../../molecules/checkboxQuestion';
import { Q } from '../../../store/student/types';
import { IRegionConfig } from '../../../types';
import { useCustomNavigate } from '../../../hooks/useCustomNavigate';
import { useDispatch } from 'react-redux';
import { updateInfoProcessing } from '../../../store/student/core/actions';

export interface IProps {
  complete: boolean;
  infoProcessingConsent: boolean;
  config: IRegionConfig;
}

type Props = IProps;

const InfoProcessing = (props: Props) => {
  const { navigateForward } = useCustomNavigate();

  const onNext = () => navigateForward();

  const dispatch = useDispatch();
  const onChange = (info: boolean, config: IRegionConfig) => dispatch(updateInfoProcessing(info, config));

  const handleChange = (_key: string, isTicked: boolean) => {
    onChange(isTicked, props.config);
  };

  return (
    <QuestionPage section="Info Processing" complete={props.complete} hideProgress={true} onNext={onNext}>
      <Checkbox
        key={Q.INFO_PROCESSING}
        id={Q.INFO_PROCESSING}
        label={props.config?.Checklist?.InfoProcessing?.title}
        blurb={props.config?.Checklist?.InfoProcessing?.blurb}
        isTicked={props.infoProcessingConsent}
        checkboxLabel={'I Agree'}
        onChange={handleChange}
      />
    </QuestionPage>
  );
};

export default InfoProcessing;
